import * as React from 'react';
import { SectionNotificationType, SectionNotificationSize, } from './types';
import { SectionNotificationButton } from './Button/SectionNotificationButton';
import { SectionNotificationText } from './Text/SectionNotificationText';
import { SectionNotificationIcon } from './Icon/SectionNotificationIcon';
import { st, classes } from './SectionNotification.st.css';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { SectionNotificationProvider } from './SectionNotificationContext';
import uniqueId from '../../common/uniqueId';
/** Section notification displays an important, succinct message, and provides actions for users to address and can not be dismissed.  */
export class SectionNotification extends React.Component {
    static { this.displayName = 'SectionNotification'; }
    static { this.defaultProps = {
        type: SectionNotificationType.default,
        size: SectionNotificationSize.regular,
    }; }
    static { this.Text = SectionNotificationText; }
    static { this.Icon = SectionNotificationIcon; }
    static { this.Button = SectionNotificationButton; }
    constructor(props) {
        super(props);
        this.contentId = uniqueId('section-notification-contents-wrapper_');
    }
    render() {
        const { children, type, className, size, 'aria-label': ariaLabel, } = this.props;
        const isError = type === SectionNotificationType.error;
        const isAlert = type === SectionNotificationType.alert;
        const isWired = type === SectionNotificationType.wired;
        const isSuccess = type === SectionNotificationType.success;
        const contents = [];
        const buttons = [];
        React.Children.forEach(children, (child) => {
            if (child && child.type === SectionNotificationButton) {
                buttons.push(child);
            }
            else {
                contents.push(child);
            }
        });
        const role = buttons.length
            ? 'group'
            : isError || isSuccess
                ? 'alert'
                : 'status';
        return (React.createElement(TPAComponentsConsumer, null, ({ rtl }) => {
            return (React.createElement("div", { className: st(classes.root, {
                    error: isError,
                    alert: isAlert,
                    rtl,
                    size,
                    wired: isWired,
                    success: isSuccess,
                }, className), role: role, "data-error": isError, "data-alert": isAlert, "data-wired": isWired, "data-success": isSuccess, "data-hook": this.props['data-hook'], "aria-label": ariaLabel, "aria-describedby": this.contentId },
                React.createElement("div", { className: classes.main },
                    React.createElement("div", { className: classes.contentsWrapper, id: this.contentId }, contents),
                    buttons ? (React.createElement(SectionNotificationProvider, { value: { type } },
                        React.createElement("div", { className: classes.buttonsWrapper }, buttons))) : null)));
        }));
    }
}
//# sourceMappingURL=SectionNotification.js.map